/* Custom Mega Menu */

document.addEventListener('mouseover', function (event) {
  const trigger = event.target.closest('.mega-menu__locations-link');
  if (!trigger) return;

  const root = trigger.closest('.mega-menu__locations');
  if (!root) return;

  const index = trigger.getAttribute('data-locations-index');

  root.querySelectorAll('.mega-menu__locations-link').forEach((link) => {
    link.classList.toggle('is-active', link === trigger);
  });

  root.querySelectorAll('.mega-menu__locations-image-item').forEach((panel) => {
    panel.classList.toggle('is-active', panel.getAttribute('data-locations-panel') === index);
  });
});

document.addEventListener('focusin', function (event) {
  const trigger = event.target.closest('.mega-menu__locations-link');
  if (!trigger) return;

  const root = trigger.closest('.mega-menu__locations');
  if (!root) return;

  const index = trigger.getAttribute('data-locations-index');

  root.querySelectorAll('.mega-menu__locations-link').forEach((link) => {
    link.classList.toggle('is-active', link === trigger);
  });

  root.querySelectorAll('.mega-menu__locations-image-item').forEach((panel) => {
    panel.classList.toggle('is-active', panel.getAttribute('data-locations-panel') === index);
  });
});

/* Custom Salon Carousel */

(() => {
  const initSalonCarousel = (carousel) => {
    if (!carousel || carousel.dataset.carouselInitialized === 'true') return;

    const slides = Array.from(carousel.querySelectorAll('[data-carousel-slide]'));
    const dots = Array.from(carousel.querySelectorAll('[data-carousel-dot]'));

    if (slides.length < 2) return;

    carousel.dataset.carouselInitialized = 'true';

    let currentIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
    if (currentIndex < 0) currentIndex = 0;

    const delay = Number(carousel.dataset.delay) || 3000;
    let timer = null;
    let transitionToken = 0;

    const preloadSlideImage = (index) => {
      const slide = slides[index];
      if (!slide) return;

      const image = slide.querySelector('img');
      if (!image) return;

      image.loading = 'eager';
    };

    const setActiveSlide = (index) => {
      if (index === currentIndex) return;

      const token = ++transitionToken;
      const targetSlide = slides[index];
      const targetImage = targetSlide ? targetSlide.querySelector('img') : null;

      preloadSlideImage(index);

      const activateSlide = () => {
        if (token !== transitionToken) return;

        slides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === index;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });

        dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === index;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        });

        currentIndex = index;

        const nextIndex = currentIndex + 1 >= slides.length ? 0 : currentIndex + 1;
        preloadSlideImage(nextIndex);
      };

      if (targetImage && !targetImage.complete) {
        targetImage.addEventListener('load', activateSlide, { once: true });
        targetImage.addEventListener('error', activateSlide, { once: true });
      } else {
        activateSlide();
      }
    };

    const nextSlide = () => {
      const nextIndex = currentIndex + 1 >= slides.length ? 0 : currentIndex + 1;
      setActiveSlide(nextIndex);
    };

    const stopAutoplay = () => {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    };

    const startAutoplay = () => {
      if (document.hidden) return;

      stopAutoplay();
      timer = window.setInterval(nextSlide, delay);
    };

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        setActiveSlide(index);
        startAutoplay();
      });
    });

    carousel.addEventListener('mouseenter', stopAutoplay);
    carousel.addEventListener('mouseleave', startAutoplay);
    carousel.addEventListener('focusin', stopAutoplay);
    carousel.addEventListener('focusout', startAutoplay);

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        stopAutoplay();
      } else {
        startAutoplay();
      }
    });

    preloadSlideImage(currentIndex);
    preloadSlideImage(currentIndex + 1 >= slides.length ? 0 : currentIndex + 1);

    if (!(window.Shopify && window.Shopify.designMode)) {
      startAutoplay();
    }
  };

  const initSalonCarousels = (root = document) => {
    root.querySelectorAll('[data-carousel]').forEach(initSalonCarousel);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initSalonCarousels());
  } else {
    initSalonCarousels();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initSalonCarousels(event.target);
  });
})();